<template>
    <span>
        <SvgIcon
            v-if="icon === 'user'"
            width="20px"
            height="22px"
            icon="user"
        />
        <SvgIcon
            v-if="icon === 'heart'"
            width="20px"
            height="18px"
            icon="heart"
        />
        <SvgIcon
            v-if="icon === 'card'"
            width="24px"
            height="18px"
            icon="card"
        />
        <SvgIcon
            v-if="icon === 'big-star'"
            width="22px"
            height="22px"
            icon="star"
        />
        <img 
            v-if="icon === 'chat'" 
            :src="`${$store.state.appUrl}/img/pwa/chat.svg`"
            width="24px"
            height="18px" />
            
        <SvgIcon v-if="icon === 'star'" class="h-6 w-6" icon="star" />
        <SvgIcon v-if="icon === 'mail'" class="h-6 w-6" icon="mail" />
        <SvgIcon v-if="icon === 'lock'" class="h-6 w-6" icon="lock" />
        <SvgIcon v-if="icon === 'chevron'" class="h-6 w-6" icon="chevron" />
        <span v-else></span>
    </span>
</template>

<script>
import SvgIcon from "../UI/SvgIcon";
export default {
    name: "FormIcons",
    components: { SvgIcon },
    props: ["icon"]
};
</script>
